import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getStoredLocale } from "./constants";

import esCommon from "./locales/es/common.json";
import esNav from "./locales/es/nav.json";
import esCookies from "./locales/es/cookies.json";
import esResourcesPage from "./locales/es/resourcesPage.json";
import esLegalPage from "./locales/es/legalPage.json";
import esAssistant from "./locales/es/assistant.json";

import enCommon from "./locales/en/common.json";
import enNav from "./locales/en/nav.json";
import enCookies from "./locales/en/cookies.json";
import enResourcesPage from "./locales/en/resourcesPage.json";
import enLegalPage from "./locales/en/legalPage.json";
import enAssistant from "./locales/en/assistant.json";

export const defaultNS = "common";

/* Resources are bundled, so initialise synchronously: the prerenderer and the
   first client render must see translations without suspending. */
void i18n.use(initReactI18next).init({
  initAsync: false,
  react: { useSuspense: false },
  lng: getStoredLocale(),
  fallbackLng: "es",
  supportedLngs: ["es", "en"],
  defaultNS,
  ns: [
    "common",
    "nav",
    "cookies",
    "resourcesPage",
    "legalPage",
    "assistant",
  ],
  resources: {
    es: {
      common: esCommon,
      nav: esNav,
      cookies: esCookies,
      resourcesPage: esResourcesPage,
      legalPage: esLegalPage,
      assistant: esAssistant,
    },
    en: {
      common: enCommon,
      nav: enNav,
      cookies: enCookies,
      resourcesPage: enResourcesPage,
      legalPage: enLegalPage,
      assistant: enAssistant,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
